import { createApiRef } from '@backstage/core-plugin-api';

const licensedUsersApiRef = createApiRef({
  id: "plugin.licensed-users-info.service"
});
class LicensedUsersAPIClient {
  // @ts-ignore
  configApi;
  identityApi;
  constructor(options) {
    this.configApi = options.configApi;
    this.identityApi = options.identityApi;
  }
  async isLicensePluginEnabled() {
    const { token: idToken } = await this.identityApi.getCredentials();
    const backendUrl = this.configApi.getString("backend.baseUrl");
    const jsonResponse = await fetch(
      `${backendUrl}/api/licensed-users-info/health`,
      {
        headers: {
          ...idToken && { Authorization: `Bearer ${idToken}` }
        }
      }
    );
    return jsonResponse.ok;
  }
  async downloadStatistics() {
    const { token: idToken } = await this.identityApi.getCredentials();
    const backendUrl = this.configApi.getString("backend.baseUrl");
    const response = await fetch(
      `${backendUrl}/api/licensed-users-info/users`,
      {
        method: "GET",
        headers: {
          ...idToken && { Authorization: `Bearer ${idToken}` },
          "Content-Type": "text/csv"
        }
      }
    );
    return response;
  }
}

export { LicensedUsersAPIClient, licensedUsersApiRef };
//# sourceMappingURL=LicensedUsersClient.esm.js.map
